import { render, staticRenderFns } from "./TireLocationPicker.vue?vue&type=template&id=3585f580&"
import script from "./TireLocationPicker.controller.js?vue&type=script&lang=js&"
export * from "./TireLocationPicker.controller.js?vue&type=script&lang=js&"
import style0 from "./TireLocationPicker.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports